// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "steel-models" + "." + "1794a03c" + ".js";
};